<template>
        <card shadow>
            <div class="row">
            <div class="col-md-4  text-center">
                <h3>
                    <i class="ni ni-cloud-upload-96"></i>
                    Dokument von PC hochladen
                </h3>
                <!---- https://rowanwins.github.io/vue-dropzone/docs/dist/index.html#/installation ---->
                    <vue-dropzone :options="dropzoneOptions"  ref="upload" id="dropzone" :useCustomSlot=true :duplicateCheck=true v-on:vdropzone-success="selectFileAfterUpload">
                        <div class="dropzone-custom-content">
                            <h3 class="dropzone-custom-title text-info">Dateien hier per Drag&Drop hinzufügen</h3>
                            <div class="subtitle">... oder hier klicken und von Computer auswählen</div>
                        </div>
                    </vue-dropzone>
            </div>

            <div class="col-md-8 text-center">
                <h3 class="text-center">
                    <i class="fas fa-cloud"></i>
                    Dokument von Server auswählen
                </h3>
                    <base-table :data="files"
                                class="scrollable"
                                :class="type === 'dark' ? 'table-dark': ''"
                                :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                                :loadmore="currentPage < totalpages && !isLoadingData"
                                @expand-table="loadMore"
                                tbody-classes="list">
                        <template slot="columns">
                            <th v-on:click="order('fileExtension',(orderdir === 'desc' ) ? 'asc' : 'desc')"  style="width:15%;" class="align-middle" v-if="expanded">
                                <i class="fas fa-sort"></i>
                                Dateityp</th>
                            <th v-if="isAdmin" style="white-space: normal !important;"><div class="col-auto"><span><i class="ni ni-collection"></i> Organisation</span></div></th>
                            <th v-on:click="search = !search" style="white-space: normal !important;">
                                <div class="form-row align-items-center">
                                    <div class="col-auto">
                                        <span v-on:click="order('fileName',(orderdir === 'desc' ) ? 'asc' : 'desc')"><i   class="fas fa-sort"></i> Dateiname</span>
                                    </div>
                                    <div class="col-auto">
                                        <base-input v-model="searchfield" input-classes="search-field form-control-sm" form-classes="mb-0" append-span-classes="form-control-sm" addonRightIcon="fas fa-search"></base-input>
                                    </div>
                                </div>
                            </th>
                            <th v-on:click="order('createdAt',(orderdir === 'desc' ) ? 'asc' : 'desc')" style="width:25%;white-space: normal !important;" class="align-middle"><i   class="fas fa-sort"></i> Hochgeladen am</th>
                            <th></th>
                        </template>
                        <template slot-scope="{row}">
                            <th v-on:click="selectFile(row['@id'])" style="width:15%; padding-top: 8px; padding-bottom: 8px;" scope="row" v-if="expanded">
                                <div v-if="isLoading" class="loading"> </div>
                                <div v-else>
                                        <div :class="['avatar', (file !== row['@id']) ? 'bg-primary' : 'bg-success']">
                                            <transition name="fade" mode="out-in">
                                                <span v-if="file !== row['@id']">{{row.fileExtension.toUpperCase() }}</span>
                                                <span v-else ><i class="fas fa-check"></i></span>
                                            </transition>
                                        </div>
                                </div>
                            </th>
                            <td v-if="isAdmin" v-on:click="selectFile(row['@id'])" style="white-space: normal !important;">
                                <div v-if="isLoading" class="loading"> </div><div v-else>{{(row.customer) ? $store.getters['customer/showCustomerByIRI'](row.customer['@id']).name : ''}}</div>
                            </td>
                            <td v-on:click="selectFile(row['@id'])" style="white-space: normal !important;">
                                <div v-if="isLoading" class="loading" style="width:40%;"> </div><div v-else class="text-left"><a href="#" @click.prevent="downloadFileAndShowDocumentViewer(row['@id'].split('s/')[1])">{{row.fileName}}</a></div>
                            </td>
                            <td v-on:click="selectFile(row['@id'])" style="white-space: normal !important;">
                                <div v-if="isLoading" class="loading" style="width:25%;"> </div><div v-else class="text-right">{{row.createdAt  | formatDateShort }}</div>
                            </td>
                            <td><div v-if="isLoading" class="loading-button"> </div><div v-else>
                                <base-dropdown class="dropdown"
                                               position="right">
                                    <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <template>
                                        <ul class="dropdown-item" @click="deleteFile(row['@id'])"><i class="fas fa-calendar-day" alt="Datei löschen"></i>Datei löschen</ul>
                                    </template>
                                </base-dropdown>
                            </div></td>
                        </template>
                    </base-table>
                </div>
            </div>
        </card>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import {authHeader} from '@/_helpers'



    let header = authHeader();
    //header['Content-Type'] = 'application/json';
    header['Access-Control-Allow-Origin'] = null;
    header['Cache-Control'] = null;
    header['X-Requested-With'] = null;


    export default {
        name:"upload-field-main",
        props:{
            url: {
                type: String,
                description: "url to upload and host",
                default: ''
            },
            expanded: {
                type: Boolean,
                description: "show select column",
                default: true
            }
        },
        components:{
            vueDropzone:vue2Dropzone
        },
        data() {
            return {
                file: null,
                type: 'light',
                search: false,
                searchfield: '',
                documents: [
                    {
                        '@id': null,
                        fileExtension: '',
                        fileName: '',
                        createdAt: null
                    },
                ],
                dropzoneOptions:{
                    url: '',
                    thumbnailWidth:150,
                    maxFilesize:2,
                    headers: header
                },
                isLoadingData: false,
                orderby: 'id',
                orderdir: 'desc',
              currentPage: 1,
              totalpages: 1
            }
        },
        created(){
          this.isLoadingData = true
            this.init(this.orderby,this.orderdir);
            this.dropzoneOptions.url = this.url;
            if(!this.$store.getters['customer/isReady'] || !this.$store.getters['customer/isLoading']) {
                this.$store.dispatch('customer/getCustomerCollection')
            }
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            files() {
                return this.filterFilenames(this.searchfield);
            },
            isLoading() {
                return this.isLoadingData || !this.$store.getters['customer/isReady']
            }
        },
        methods:{
            init(orderby,orderdir) {
                this.isLoadingData = true;
                this.getTableData(orderby,orderdir).then(response => {
                  if (this.documents[0]['@id'] === null ) this.documents = [];
                  this.documents = this.documents.concat(response.member);
                  this.totalpages = Math.ceil(response.totalItems / 30)
                  this.isLoadingData = false;
                }).catch(error => {
                  this.$store.dispatch('alert/error',error);
                });
            },
            order(orderby,orderdir) {
                this.orderby = orderby;
                this.orderdir = orderdir;
                this.documents = [{
                  '@id': null,
                  fileExtension: '',
                  fileName: '',
                  createdAt: null
                }];
                this.init(orderby,orderdir);
            },
          loadMore() {
              this.currentPage++;
              this.init(this.orderby,this.orderdir)
          },
            getTableData(orderby,orderdir) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method:'GET',
                        headers:header
                    };

                    fetch(this.url + `?page=` + this.currentPage + `&false&order[`+orderby+`]=`+orderdir, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems:response['hydra:totalItems'],
                                member:response['hydra:member']
                            });

                        }, error => {
                            reject(error);
                        });
                });
            },
            selectFile(fileid){
                if (this.file !== fileid) {
                    this.file = fileid;
                } else  {
                    this.file = null
                }
            },
            selectFileAfterUpload(file, response) {
                this.init(this.orderby,this.orderdir);
                this.file = response['@id'];
            },
            filterFilenames(name) {
                return Array.from(this.documents).filter(item => { return item.fileName.toLowerCase().includes(name.toLowerCase())})
            },
            deleteFile(iri) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method:'DELETE',
                        headers:header
                    };

                    fetch(process.env.VUE_APP_API_SERVER +  iri, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            this.$store.dispatch('alert/success', 'Die Datei wurde erfolgreich gelöscht!');
                            this.init(this.orderby,this.orderdir);
                            resolve(response);
                        }, error => {
                            this.$store.dispatch('alert/error', error);
                            reject(error);
                        });
                });
            },
        }
    }
</script>

<style scoped>
    .dropzone-custom-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }

    .dropzone-custom-title {
        margin-top: 0;
    }

    .dropzone {
        height: 80%;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }

    .subtitle {
        color: #314b5f;
    }

    .search-field {
        display: inline-block;
    }

    .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        font-size: 18px;
        background-color: rgb(23, 43, 77);
        background-image: none;
    }


</style>